import UserPage from "src/pages/User";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import {
  getUserServerSideProps,
  getUserPageJoinsFeed,
} from "src/utilities/ssr/getUserServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getUserServerSideProps(getUserPageJoinsFeed)
);

export default withPropsDeserialization(UserPage);
